import { render, staticRenderFns } from "./StageGames1x1.vue?vue&type=template&id=3b3baa2e&scoped=true&"
import script from "./StageGames1x1.vue?vue&type=script&lang=js&"
export * from "./StageGames1x1.vue?vue&type=script&lang=js&"
import style0 from "./StageGames1x1.vue?vue&type=style&index=0&id=3b3baa2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3baa2e",
  null
  
)

export default component.exports